import { atom } from "recoil";
import { BusinessDTO } from "../Types-DTOs/ClientUser";
import { localStorageEffect } from "./Utils";
import { Invitation } from "../Types-DTOs/Invitation";

export type BusinessState = {
  business: BusinessDTO | undefined;
  invites: Array<Invitation> 
};

export const businessState = atom<BusinessState>({
  key: "businessState",
  default: {} as BusinessState,
  effects: [localStorageEffect<BusinessState>("businessState")],
});
